(() => {
  if (window.__joffzCartV47) return;
  window.__joffzCartV47 = true;

  const currentContextUrl = () => `${window.location.pathname}${window.location.search}`;
  const previewThemeId = () => new URL(window.location.href).searchParams.get('preview_theme_id');
  const normalizePath = (value) => String(value || '/').replace(/\/{2,}/g, '/').replace(/\/$/, '') || '/';

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    try {
      const rawUrl = typeof input === 'string' ? input : input?.url;
      const url = new URL(rawUrl, window.location.origin);
      const cartAddPath = normalizePath(window.routes?.cart_add_url || '/cart/add');
      const cartChangePath = normalizePath(window.routes?.cart_change_url || '/cart/change');
      const cartPath = normalizePath(window.routes?.cart_url || '/cart');
      let nextInput = input;
      let nextInit = init;

      if (url.origin === window.location.origin) {
        const path = normalizePath(url.pathname);

        if (path === cartAddPath || path === cartChangePath) {
          if (init.body instanceof FormData) {
            init.body.set('sections_url', currentContextUrl());
          } else if (typeof init.body === 'string') {
            try {
              const payload = JSON.parse(init.body);
              if (payload && Object.prototype.hasOwnProperty.call(payload, 'sections_url')) {
                payload.sections_url = currentContextUrl();
                nextInit = { ...init, body: JSON.stringify(payload) };
              }
            } catch (error) {}
          }
        }

        if (path === cartPath && url.searchParams.has('section_id')) {
          const themeId = previewThemeId();
          if (themeId && !url.searchParams.has('preview_theme_id')) {
            url.searchParams.set('preview_theme_id', themeId);
            nextInput = `${url.pathname}${url.search}${url.hash}`;
          }
        }
      }

      return nativeFetch(nextInput, nextInit);
    } catch (error) {
      return nativeFetch(input, init);
    }
  };

  const syncViewBagLink = (root = document) => {
    const link = root.querySelector?.('.joffz-cart__continue');
    if (!link) return;

    const url = new URL(window.routes?.cart_url || '/cart', window.location.origin);
    url.searchParams.set('view', 'page');
    const themeId = previewThemeId();
    if (themeId) url.searchParams.set('preview_theme_id', themeId);
    link.href = `${url.pathname}${url.search}`;
    link.dataset.cartPageLink = 'true';
  };

  const syncDrawerState = (drawer = document.querySelector('cart-drawer.joffz-cart-minimal')) => {
    if (!drawer) return;
    if (drawer.joffzCartVersion === 60) {
      drawer.syncState();
      return;
    }
    const hasItems = Boolean(drawer.querySelector('.drawer__cart-items-wrapper .cart-item'));
    const empty = !hasItems;
    drawer.classList.toggle('is-empty', empty);
    drawer.querySelector('cart-drawer-items')?.classList.toggle('is-empty', empty);
    const footer = drawer.querySelector('.drawer__footer');
    if (footer) footer.hidden = empty;
    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = empty;
    syncViewBagLink(drawer);
  };

  const patchDrawer = () => {
    const Drawer = customElements.get('cart-drawer');
    if (Drawer?.prototype.joffzCartVersion === 60) return;
    if (!Drawer || Drawer.prototype.__joffzV47Patched) return;
    Drawer.prototype.__joffzV47Patched = true;

    const baseRender = Drawer.prototype.renderContents;
    if (typeof baseRender === 'function') {
      Drawer.prototype.renderContents = function renderContentsV47(state) {
        baseRender.call(this, state);
        requestAnimationFrame(() => syncDrawerState(this));
        window.setTimeout(() => syncDrawerState(this), 80);
      };
    }
  };

  const init = () => {
    patchDrawer();
    syncDrawerState();
    syncViewBagLink();
  };

  if (customElements.get('cart-drawer')) patchDrawer();
  else customElements.whenDefined('cart-drawer').then(patchDrawer).catch(() => {});

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('cart:change', () => {
    requestAnimationFrame(() => syncDrawerState());
    window.setTimeout(() => syncDrawerState(), 80);
  });

  document.addEventListener('variant:add', () => {
    window.setTimeout(() => syncDrawerState(), 80);
  });

  document.addEventListener('shopify:section:load', init);
})();
